import { createFileRoute, redirect } from '@tanstack/react-router'
import { CategoriesPage } from '@/features/settings/categories/CategoriesPage'
import { queryClient } from '@/lib/query'
import { getGetAllCategoriesQueryKey, getAllCategories } from '@/utils/api/membership-service'
import { isAdminUser } from '@/lib/role-guards'

export const Route = createFileRoute('/_authenticated/settings/categories')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: CategoriesPage,
  loader: async () => {
    // Prefetch categories data when route loads
    await queryClient.ensureQueryData({
      queryKey: getGetAllCategoriesQueryKey(),
      queryFn: () => getAllCategories(),
    })
  },
})
